<template>
  <div>
    <HomeDetailInfoSiteOne>
      <template #header-one>
        <h1 style="max-width: 800px"> Show your process structure and your product structure in the same TAKT.plan </h1>
      </template>
      <template #text-one>
        <p :style="`max-width: 700px;
        font-style: normal;
        font-size: 20px;

        ${$vuetify.breakpoint.smAndDown ? 'padding: 50px 20px 20px 20px' : 'padding: 50px 20px 30px 20px;'}`">
    The production process structure isn’t often overlapping with the structure of you building.
    Therefore, you should make the different structures transparent for all parties on site.
    TAKT.app is able to switch both structures with all content. It enables your production on site to be more flexibles.
    </p>
      </template>
      <template #image>
        <div :style="`display: flex;  ${$vuetify.breakpoint.smAndDown ? 'flex-direction:column;' : 'flex-direction:row;'}; gap: 15px; align-items: center`">
        <img :width="$vuetify.breakpoint.smAndDown ? '90%' : '41.3%' " src="@/assets/TaktNews-ProjectStructureOne.png">
        <img :width="$vuetify.breakpoint.smAndDown ? '90%' : '40%' " src="@/assets/TaktNews-ProjectStructureTwo.png">




        </div>
      </template>
    </HomeDetailInfoSiteOne>
  </div>
</template>

<script>
import HomeDetailInfoSiteOne from '@/components/Home/HomeDetailInfoSiteOne.component.vue'

export default {
  components: {
    HomeDetailInfoSiteOne
  }
}
</script>
